import translations from './translations'

translations.add('pt', {
    headerMessage: 'Já pagou usando o seu aplicativo bancário?',
    no: 'Não',
    yes: 'Sim'
})
